import { useEffect, useState } from 'react'
import useProviderFhirResource from './useProviderFhirResource'

interface Payload {
  resource?: string
  resourceId?: string
  searchTerms?: string
}

const usePaginatedProviderFhirResource = (initialPayload: Payload, pageSize: number) => {
  const [page, setPage] = useState('1')
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerms, setSearchTerms] = useState(initialPayload.searchTerms)

  const payload = {
    ...initialPayload,
    page,
    pageSize
  }

  const {
    data,
    refetch,
    isLoading,
    isSuccess,
    remove,
    isFetching,
    isError
  } = useProviderFhirResource(payload)

  const totalPages = data?.total ? Math.ceil(data.total / pageSize) : 1

  useEffect(() => {
    refetch()
  }, [page, refetch])

  useEffect(() => {
    setPage('1')
    setCurrentPage(1)
  }, [initialPayload.resource])

  const handleChangePage = (pageNumber: number) => {
    const relation =
      pageNumber > currentPage ? 'next' :
        pageNumber < currentPage ? 'previous' :
          'self'

    const link = data?.links?.find(
      (link: any) => link.relation === relation
    )

    const pageValue = link
      ? new URL(link.url).searchParams.get('page')
      : null

    setPage(pageValue || pageNumber.toString())
    setCurrentPage(pageNumber)
  }

  const handleNewSearch = () => {
    if (initialPayload.searchTerms !== searchTerms) {
      setSearchTerms(initialPayload.searchTerms)
      setPage('1')
      setCurrentPage(1)
    }
  }

  return {
    data,
    refetch,
    isSuccess,
    isLoading,
    remove,
    isError,
    isFetching,
    handleChangePage,
    totalPages,
    currentPage,
    handleNewSearch
  }
}

export default usePaginatedProviderFhirResource